import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button, Alert, CircularProgress } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export default function ImportStepConfirm({ typeConfig, headers, rows, onBack, onReset, onDone, loading, error }) {
    const [t] = useTranslation();

    return (
        <Box sx={{ textAlign: 'center', py: 3 }}>
            <CheckCircleOutlineIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />

            <Typography variant="h6" fontWeight="bold" gutterBottom>
                {t('Ready to Import')}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                {t('{{count}} records will be imported into {{label}}.', {
                    count: rows.length,
                    label: t(typeConfig?.label || ''),
                })}
            </Typography>

            <Alert severity="info" sx={{ textAlign: 'left', mb: 3 }}>
                {t('This will add {{count}} new records. Existing records will not be modified.', {
                    count: rows.length,
                })}
            </Alert>

            {error && (
                <Alert severity="error" sx={{ textAlign: 'left', mb: 3 }}>
                    {error}
                </Alert>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Button onClick={onBack} color="inherit" disabled={loading}>
                    {t('Back')}
                </Button>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button onClick={onReset} variant="outlined" disabled={loading}>
                        {t('Start Over')}
                    </Button>
                    <Button
                        variant="contained"
                        color="success"
                        onClick={onDone}
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
                    >
                        {loading ? t('Importing...') : t('Import')}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}
